/** Start of UTC calendar day for date comparisons (matches kserver). */
function startOfUtcDay(d: Date): Date {
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
}

/** True when the notice can be acted on (effective date is today or in the past). */
export function isAssignmentEffective(effectiveDateIso: string, now = new Date()): boolean {
  const effective = new Date(effectiveDateIso);
  if (Number.isNaN(effective.getTime())) {
    return true;
  }
  return startOfUtcDay(effective).getTime() <= startOfUtcDay(now).getTime();
}

export type NoticeCalendarDateStyle = 'short' | 'long';

/** Date-only display for Sent on / Applies from (UTC calendar day, no time). */
export function formatNoticeCalendarDate(
  iso: string | null | undefined,
  locale = 'en-IN',
  monthStyle: NoticeCalendarDateStyle = 'short'
): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: monthStyle === 'long' ? 'long' : 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatEffectiveDateLabel(effectiveDateIso: string, locale = 'en-IN'): string {
  return formatNoticeCalendarDate(effectiveDateIso, locale, 'short');
}
